export default __webpack_public_path__ + "static/media/webbing_type.3f96a680.jpeg";